import { render, staticRenderFns } from "./ExchangeDetails.vue?vue&type=template&id=c42784a8&"
import script from "./ExchangeDetails.vue?vue&type=script&lang=js&"
export * from "./ExchangeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports